import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import moment from 'moment';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import avatar from '@material-ui/core/colors/grey';



import BidStatus from './BidStatus';
import { startEditAdmin } from '../../../store/actions/admin';
import { selectBidStatus } from '../../../store/selectors/bidStatus';

import classNames from 'classnames';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
  client: {
    width: "120px",
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: grey[100],
    }
  },
  flexGrow: {
    flexGrow: 1,
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
  total: {
    flexBasis: '80px',
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  statusMessage: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: "center",
  },
  statusMessageSpacer: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
    height: "7px",
    width: "7px",
    backgroundColor: "#bbb",
    borderRadius: "50%",
  },
  jobCode: {
    width: "120px",
  }
});

//TODO: remove business logic that calculates totals, should be done in Bids
// but unfortunately bids and its tasks was denormalized. Either refactor the bids
//state to be normalized or create helper functions/class to do this.
const BidCard = ({ classes, bid, bidState, bidTasks, client, type, startEditAdmin  }) => {

  const statusColor = function () {
    if (bidState.statusMessage === undefined) {
      return undefined;
    } else if (bidState.statusMessage.status === undefined) {
      return undefined;
    } else if (bidState.statusMessage.status === "overdue") {
      return red[500];
    } else if (bidState.statusMessage.status === "warning") {
      return orange[500];
    } else if (bidState.statusMessage.status === "ok") {
      return green[500];
    }
  }();

  let subtotal = 0;
  let tax = 0;
  let total = 0;
  bidTasks.forEach((bidTask) => {
      subtotal += bidTask.subtotal;
  });
  tax = subtotal*0.05;
  total = subtotal + tax;

  return(
    <Card className={classes.root}>
      <div
        className={classes.content}
        onClick={() => startEditAdmin({bid: bid})}
      >
        <Avatar className={classNames(classes.avatar, classes.margin)}>
          {type.substring(0,1).toUpperCase()}
        </Avatar>
        <div className={classNames(classes.client, classes.margin)}>
          {client &&
            <Typography noWrap variant="subheading">
              {client.fullName}
            </Typography>
          }
          <Typography>
            {bid.bidNumber !== undefined ? bid.bidNumber.toString().padStart(6, "0") : ""}
          </Typography>
        </div>
        <div className={classes.jobCode}>
          {bid.code &&
            <Typography noWrap variant="subheading">{bid.code}</Typography>
          }
          <Typography>{moment(bid.date).format("MMM Do, YYYY")}</Typography>
        </div>

        {bidState.statusMessage && bidState.statusMessage.text !== "" &&
          <div className={classes.statusMessage}>
            <div className={classes.statusMessageSpacer} />
            <Typography style={{color: statusColor}}>
              {bidState.statusMessage.text}
            </Typography>
          </div>
        }
        <div className={classes.flexGrow}/>

        <div className={classes.flexGrow}/>
        <div className={classes.divider}></div>
        <Typography className={classes.total}>${total.toFixed(2)}</Typography>
      </div>
      <div className={classes.divider}></div>
      <div className={classNames(classes.status, classes.margin)}>
        <BidStatus bid={bid} bidTasks={bidTasks} />
      </div>
    </Card>
  );
};

const mapStateToProps = (state, props) => {
  const { bid } = props;
  const client = bid.clientId === undefined
    ? undefined
    : state.clientsState.find((client) => client.id === bid.clientId);
  const bidTasks = state.bidTasksState.filter( bidTask => bidTask.bidId === bid.id);
  const type = bidTasks[0] === undefined ? "bid" : bidTasks[0].type;

  return {
    client: client,
    bidTasks: bidTasks,
    bidState: selectBidStatus(state, bid.id),
    type: type,
  };
};

const mapDispatchToProps = (dispatch) => ({
  startEditAdmin: (bid) => dispatch(startEditAdmin(bid))
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(BidCard);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/BidCard.jsx